import script from "./modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./modal.vue?vue&type=script&lang=ts&setup=true"

import "./modal.vue?vue&type=style&index=0&id=3b5449b0&lang=scss"

const __exports__ = script;

export default __exports__